module.exports = __webpack_public_path__ + "img/img-placeholder.f72210f8.png";